/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  LauncherCandidate,
  LauncherCandidate$Outbound,
  LauncherCandidate$outboundSchema,
} from "./launchercandidate.js";
import {
  LauncherContext,
  LauncherContext$Outbound,
  LauncherContext$outboundSchema,
} from "./launchercontext.js";

export type JudgeRequestBody = {
  /**
   * Fuzzy-prefiltered candidates to rank.
   */
  candidates: Array<LauncherCandidate>;
  /**
   * The dashboard location the palette was opened from.
   */
  context?: LauncherContext | undefined;
  /**
   * Text typed into the command palette so far.
   */
  query: string;
};

/** @internal */
export type JudgeRequestBody$Outbound = {
  candidates: Array<LauncherCandidate$Outbound>;
  context?: LauncherContext$Outbound | undefined;
  query: string;
};

/** @internal */
export const JudgeRequestBody$outboundSchema: z.ZodMiniType<
  JudgeRequestBody$Outbound,
  JudgeRequestBody
> = z.object({
  candidates: z.array(LauncherCandidate$outboundSchema),
  context: z.optional(LauncherContext$outboundSchema),
  query: z.string(),
});

export function judgeRequestBodyToJSON(
  judgeRequestBody: JudgeRequestBody,
): string {
  return JSON.stringify(
    JudgeRequestBody$outboundSchema.parse(judgeRequestBody),
  );
}
